<section class="funding-screen tw-w-full" data-cy="funding-screen">

  <!-- Heading: rounded bar holding the title, the tab pills and the close
       affordance (mirrors the Promotions bar / Account Settings header). -->
  <header
    class="
      heading-section
      tw-flex
      tw-items-center
      tw-flex-wrap
      tw-gap-[8px]
      tw-bg-[#F0F0F0]
      tw-rounded-[12px]
      tw-p-[10px_18px]
      tw-mb-[16px]
    "
    data-cy="funding-header"
  >
    <!-- Back is only useful while a payment method is expanded. -->
    <!-- <button
      *ngIf="methodType"
      type="button"
      (click)="cancel()"
      class="funding-back tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 tw-cursor-pointer"
      aria-label="Back to funding options"
      data-cy="funding-back"
    >
      <mat-icon class="!tw-text-[22px]">arrow_back</mat-icon>
    </button> -->

    <h3
      class="title tw-font-bold tw-text-[18px] tw-tracking-[0.5px] tw-m-0 tw-mr-[8px]"
      data-cy="funding-title"
    >
      {{ 'account.funding' | translate: 'Funding' }}
    </h3>

    <ng-container *ngFor="let tab of tabs">
      <button
        *ngIf="!isTabHidden(tab.id)"
        type="button"
        (click)="selectTab(tab.id)"
        class="
          funding-tab
          tw-rounded-[5px]
          tw-px-[16px]
          tw-py-[8px]
          tw-font-bold
          tw-text-[15px]
          tw-border-0
          tw-cursor-pointer
          tw-transition-colors
        "
        [ngClass]="activeTab === tab.id
          ? 'active tw-bg-[#2F80EC] tw-text-[#FFFFFF] tw-shadow-sm'
          : 'tw-bg-[#DADADA] tw-text-[#B9B9B9]'"
        [attr.data-cy]="tab.dataCy"
      >
        {{ tab.labelKey | translate: tab.label }}
      </button>
    </ng-container>

    <button
      type="button"
      (click)="close()"
      class="funding-close tw-ml-auto tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 tw-cursor-pointer"
      [attr.aria-label]="'generic.close' | translate: 'Close'"
      data-cy="funding-close"
    >
      <mat-icon class="!tw-text-[22px]">close</mat-icon>
    </button>
  </header>

  <!-- Tab content — its own card, separated from the heading bar -->
  <!-- tw-p-[14px_18px] -->
  <!-- tw-bg-[#F9F9F9] -->
  <div class="funding-panel tw-rounded-[12px]" data-cy="funding-panel">

    <!-- Deposit -->
    <div *ngIf="activeTab === 'deposit'" class="my-deposit-section">

      <!-- Each method is its own card: the row heads it, the body opens
           underneath (same shape as the Account Settings accordion). -->
      <div class="method-list">
        <ng-container *ngFor="let method of depositMethods; trackBy: trackByMethodId">
          <div
            *ngIf="isMethodAvailable(method)"
            class="method-card"
            [class.active]="methodType === method.id"
            [hidden]="isRowHidden(method.id)"
          >
            <div
              (click)="selectCard(method.id)"
              class="deposit-row"
              [attr.data-name]="method.id"
              [attr.data-cy]="method.dataCy"
            >
              <img [src]="method.logo" [alt]="method.labelKey | translate: method.label" class="funding-logo">
              <span
                class="row-label tw-flex-1 tw-font-bold tw-text-[16px]"
                [attr.data-cy]="method.labelDataCy"
              >
                {{ method.labelKey | translate: method.label }}
              </span>
              <mat-icon class="chev-right">{{ methodType === method.id ? 'expand_more' : 'chevron_right' }}</mat-icon>

              <!-- PayNearMe opens an external link, the component holds that behaviour. -->
              <feature-mat-pay-near-me *ngIf="method.id === 'payNearMe'"></feature-mat-pay-near-me>
            </div>

            <div
              *ngIf="methodType === method.id"
              class="card-content"
              [ngSwitch]="method.id"
              [attr.data-name]="method.id"
            >
              <feature-mat-debit-credit-card
                *ngSwitchCase="'debitAndCreditCard'"
              ></feature-mat-debit-credit-card>

              <feature-mat-crypto-currency
                *ngSwitchCase="'cryptoCurrency'"
                data-cy="deposit-crypto-screen"
              ></feature-mat-crypto-currency>

              <feature-mat-online-check-deposit
                *ngSwitchCase="'onlineCheck'"
                data-cy="deposit-ach-screen"
              ></feature-mat-online-check-deposit>

              <feature-mat-money-pak
                *ngSwitchCase="'moneyPak'"
                data-cy="deposit-moneypak-screen"
              ></feature-mat-money-pak>

              <feature-mat-wire-transfer
                *ngSwitchCase="'wireTransfer'"
                data-cy="deposit-wire-screen"
              ></feature-mat-wire-transfer>

              <feature-mat-promo-code *ngSwitchCase="'promoCode'"></feature-mat-promo-code>
            </div>
          </div>
        </ng-container>
      </div>

    </div>

    <!-- Withdraw -->
    <div *ngIf="activeTab === 'withdraw'" class="my-deposit-section">

      <!-- Options -->
      <div class="method-list">
        <ng-container *ngFor="let method of withdrawMethods; trackBy: trackByMethodId">
          <div
            *ngIf="isMethodAvailable(method)"
            class="method-card"
            [class.active]="methodType === method.id"
            [hidden]="isRowHidden(method.id)"
          >
            <div
              (click)="selectCard(method.id)"
              class="deposit-row"
              [attr.data-name]="method.id"
              [attr.data-cy]="method.dataCy"
            >
              <img [src]="method.logo" [alt]="method.labelKey | translate: method.label" class="funding-logo">
              <span
                class="row-label tw-flex-1 tw-font-bold tw-text-[16px]"
                [attr.data-cy]="method.labelDataCy"
              >
                {{ method.labelKey | translate: method.label }}
              </span>
              <mat-icon class="chev-right">{{ methodType === method.id ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </div>

            <div
              *ngIf="methodType === method.id"
              class="card-content"
              [ngSwitch]="method.id"
              [attr.data-name]="method.id"
            >
              <feature-mat-withdraw-debit-credit-card
                *ngSwitchCase="'debitAndCreditCard'"
              ></feature-mat-withdraw-debit-credit-card>

              <feature-mat-online-check-withdraw
                *ngSwitchCase="'onlineCheck'"
                data-cy="deposit-ach-screen"
              ></feature-mat-online-check-withdraw>

              <feature-mat-check-by-email
                *ngSwitchCase="'checkByEmail'"
                data-cy="withdraw-check-by-email-screen"
              ></feature-mat-check-by-email>

              <feature-mat-withdraw-wire-transfer
                *ngSwitchCase="'wireTransfer'"
                data-cy="deposit-wire-screen"
              ></feature-mat-withdraw-wire-transfer>
            </div>
          </div>
        </ng-container>
      </div>

    </div>

    <!-- Held -->
    <div *ngIf="activeTab === 'held'" class="my-held-section">
      <feature-mat-held-withdrawals></feature-mat-held-withdrawals>
    </div>

  </div>

</section>
